<template>
	<div>
		<nav class="navbar navbar-expand-lg navbar-light bg-light" style="z-index: 100000">
			<a class="navbar-brand" href="/">
				<img src="/ventisquero_smallLogo_dark.png" height="40" />
			</a>
			<button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
				aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
				<span class="navbar-toggler-icon"></span>
			</button>
			<div class="collapse navbar-collapse" id="navbarSupportedContent">
				<ul class="navbar-nav mr-auto">
					<li class="nav-item active">
						<router-link class="nav-link" to="/"><i class="fas fa-home mr-2"></i>Inicio
							<span class="sr-only">(current)</span></router-link>
					</li>
					<li v-if="isAdmin" class="nav-item dropdown bg-green">
						<a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button"
							data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
							<i class="fa fa-cogs mr-2"></i> Maestros
						</a>
						<div class="dropdown-menu bg-grren" aria-labelledby="navbarDropdown">
							<router-link class="dropdown-item link-hover" to="/users"><i
									class="fa fa-fas fa-users mr-2"></i>Usuarios<span
									class="sr-only">(current)</span></router-link>
							<router-link class="dropdown-item link-hover" to="/businessunits"><i
									class="fa fa-fas fa-city mr-2"></i>Unidad de Negocio<span
									class="sr-only">(current)</span></router-link>
							<router-link class="dropdown-item link-hover" to="/costcenters"><i
									class="fa fa-fas fa-hand-holding-usd mr-2"></i>Centro de
								Costos<span class="sr-only">(current)</span></router-link>
							<router-link class="dropdown-item link-hover" to="/couriers"><i
									class="fa fa-fas fas fa-truck mr-2"></i>Servicios de
								Transportes<span class="sr-only">(current)</span></router-link>
							<router-link class="dropdown-item link-hover" to="/sampletargets"><i
									class="fa fa-fas fa-crosshairs mr-2"></i>Objetivos de
								Muestra<span class="sr-only">(current)</span></router-link>
							<router-link class="dropdown-item link-hover" to="/materialfamilies"><i
									class="fas fa-th-list mr-2" mr-2></i>Familias de Insumos<span
									class="sr-only">(current)</span></router-link>
							<router-link class="dropdown-item link-hover" to="/samplereasons"><i
									class="far fa-dot-circle mr-2" mr-2></i>Motivos de Muestra<span
									class="sr-only">(current)</span></router-link>										
							<router-link class="dropdown-item link-hover" to="/masteritems"><i
									class="fas fa-list mr-2"></i>Maestro de
								Items<span class="sr-only">(current)</span></router-link>
							<router-link class="dropdown-item link-hover" to="/formulas"><i class="fas fa-flask mr-2"
									mr-2></i>Fórmulas<span class="sr-only">(current)</span></router-link>
							<router-link class="dropdown-item link-hover" to="/notifications"><i
									class="fas fa-mail-bulk mr-2" mr-2></i>Notificaciones<span
									class="sr-only">(current)</span></router-link>
								
						</div>
					</li>
					<li v-if="isDispatcher" class="nav-item active">
						<router-link class="nav-link" to="/solicitudes/despachadas"><i
								class="fas fa-check mr-2"></i>Solicitudes
							Despachadas<span class="sr-only">(current)</span></router-link>
					</li>
					<li class="na-item active">
						<router-link class="nav-link" to="/hotexpress-tracking"><i class="fas fa-list mr-2"></i>Seguimiento Hotexpress
							<span class="sr-only">(current)</span></router-link>
					</li>
				</ul>

				<ul class="navbar-nav" style="margin-right: 60px">
					<li v-if="isAdmin" class="nav-item active">
						<router-link class="nav-link link-hover" to="/dashboard"><i class="fas fa-chart-bar mr-2"></i>Dashboard
							<span class="sr-only">(current)</span></router-link>
					</li>
					<li class="nav-item dropdown">
						<a class="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" role="button"
							data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
							<i class="fas fa-user mr-2"></i>{{ user.fullName }}
						</a>
						<div style="left: 0" class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
							<router-link class="dropdown-item link-hover" to="/changepassword"><i
									class="fa fa-fas fa-edit mr-2"></i>Cambiar
								Contraseña</router-link>
							<router-link class="dropdown-item link-hover" to="/login"><i
									class="fa fa-fas fa-sign-out-alt mr-2"></i>Cerrar
								Sesión</router-link>
						</div>
					</li>
				</ul>
			</div>
		</nav>
	</div>
</template>

<script>
export default {
	props: ["user"],
	name: "nav-bar",
	data() {
		return {
			isAdmin: this.$store.getters.isAdmin,
			isDispatcher: this.$store.getters.isDispatcher,
			isCourier: this.$store.getters.isCourier,
		};
	},
	computed: {
		isDebug: function () {
			let url = window.location.href;
			if (url.includes("?debug=1") || url.includes("&debug=1")) return true;
			return false;
		},
	},
};
</script>

<style scoped>
.link-hover:hover {
	background-color: #811f1f !important;
	color: white !important;
}
</style>

